import { PaymentReceiptTypeEnum, PDFTypes } from '@/api/generated/models';
import { getGermanDate, uppercaseChar } from '@/plugins/Utils';

export default {
	methods: {
		makeStatus(paymentStatus, isLawyerOffice) {
			let status = ' - ';
			if (isLawyerOffice) {
				switch (paymentStatus) {
					case 'zahlungsanweisung_anwalt':
						status = PDFTypes.Mahnstatus1;
						break;
					case 'zahlungserinnerung_kunde':
						status = PDFTypes.Mahnstatus2;
						break;
					case 'letzte_mahnung':
						status = PDFTypes.Mahnstatus3;
						break;
					case 'im_mahnverfahren':
						status = PDFTypes.Mahnstatus4;
						break;
				}
			} else {
				switch (paymentStatus) {
					case 'zahlungserinnerung_kunde':
						status = PDFTypes.MahnstatusA;
						break;
					case 'letzte_mahnung':
						status = PDFTypes.MahnstatusB;
						break;
					case 'im_mahnverfahren':
						status = PDFTypes.MahnstatusC;
						break;
				}
			}

			status = uppercaseChar(status, 0);
			status = uppercaseChar(status, status.length - 1);

			return status;
		},
		makeStatusLabel(paymentStatus) {
			switch (paymentStatus) {
				case 'abgeschlossen':
					return this.$t('completed');
				case 'payment_reminder_customer_without_lawyer':
				case 'payment_reminder_customer_with_lawyer':
					return this.$t('payment_reminder_customer');
				case 'second_payment_reminder_customer_without_lawyer':
				case 'second_payment_reminder_customer_with_lawyer':
					return this.$t('second_payment_reminder_customer');
				case 'last_dunning_notice':
					return this.$t('last_dunning_notice');
				case 'first_dunning_notice':
					return this.$t('first_dunning_notice');
				default:
					return ' - ';
			}
		},
	},
	computed: {
		showWarning() {
			/*if (!this.payment?.status) {
				return true;
			}*/
			let zahlungsziel;
			if (typeof this.payment?.zahlungsziel === 'number') {
				zahlungsziel = new Date(this.payment.zahlungsziel * 1000);
			} else if (this.payment?.zahlungsziel) {
				zahlungsziel = this.payment.zahlungsziel;
			}
			const shouldBePayed = zahlungsziel && zahlungsziel < new Date();
			const isClosed = this.payment?.status === 'abgeschlossen';
			const isOverpay = this.notPayed < 0;
			return (isOverpay || shouldBePayed) && !isClosed;
		},
		isStatusOpen() {
			return !(
				(this.payment?.rechnungsbetrag && this.notPayed === 0) ||
				(this.payment?.rechnungsbetrag && this.notPayed < 0) ||
				this.payment?.status
			);
		},
		statusLabel() {
			let zahlungsziel;
			if (typeof this.payment?.zahlungsziel === 'number') {
				zahlungsziel = new Date(this.payment.zahlungsziel * 1000);
			} else if (this.payment?.zahlungsziel) {
				zahlungsziel = this.payment.zahlungsziel;
			}
			const rechnungsbetrag = this.payment?.rechnungsbetrag;
			if (rechnungsbetrag && this.notPayed === 0) {
				return this.$t('payment_completed');
			} else if (rechnungsbetrag && this.notPayed < 0) {
				return this.$t('existing_overpayment');
			} else if (!this.payment?.status && rechnungsbetrag && zahlungsziel && zahlungsziel < new Date()) {
				return this.$t('due') + ' seit ' + getGermanDate(zahlungsziel);
			} else if (this.payment?.status) {
				const paymentStatus = this.payment.status.value ?? this.payment.status;
				return this.makeStatusLabel(paymentStatus);
			}
			if (zahlungsziel === undefined) {
				return ' - ';
			}

			return this.$t('payment_due') + ' ' + getGermanDate(zahlungsziel);
		},
		status() {
			if (!this.payment?.status) {
				return ' - ';
			}
			const paymentStatus = this.payment.status.value ?? this.payment.status;
			return this.makeStatus(paymentStatus, this.process.lawyerOffice);
		},
		payed() {
			let sum = 0;

			this.payment?.zahlungen.forEach(zahlung => {
				const type = zahlung.type?.value || zahlung.type; // may from dropdown or from api
				if (!isNaN(zahlung.value) && type) {
					const value = parseFloat(zahlung.value);
					if (type?.value === PaymentReceiptTypeEnum.Refund) {
						sum -= value;
					} else {
						sum += value;
					}
				}
			});

			return sum;
		},
		notPayed() {
			return this.payment?.rechnungsbetrag - (this.payed ?? 0);
		},
	},
};
